import $ from "jquery";
import BD_Question from "@bd-components/bd-question";

export class QuestionMultipleQuestions extends BD_Question {
  constructor(questionData) {
    super();

    this.questionData = questionData;

    this.elms = {
      submit: ".js-submit",
      questionCard: ".questionCard",
      questionItem: ".js-question-item",
      answer: ".js-answer",
    };
  }

  getAnswer(ctx) {
    const answers = $(ctx.elms.answer.concat(":checked"))
      .map(function () {
        return $(this).val();
      })
      .get();
    return answers;
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "change",
        selector: elms.answer,
        handler: this.onSelectAnswer.bind(this),
        isQuestionEvent: true,
      },
    ];
  }

  onSelectAnswer() {
    // Check if all question items are answered
    const allAnswered = this.checkAllQuestionsAnswered();

    if (allAnswered) {
      $(this.elms.questionCard)
        .find(".questionCard__actions")
        .addClass("is-active");
    }
  }

  checkAllQuestionsAnswered() {
    const questionItems = $(this.elms.questionItem);
    let allAnswered = true;

    questionItems.each((index, item) => {
      const $item = $(item);
      const hasAnswer = $item.find('input[type="radio"]:checked').length > 0;

      if (!hasAnswer) {
        allAnswered = false;
        return false; // break out of each loop
      }
    });

    return allAnswered;
  }
}
